import React, { useEffect, useState } from 'react'
import { translate } from 'react-translate'
import { Button, Row, Col } from 'react-bootstrap'
import { PurposeSelector } from '../../../commons/SearchBar/components/PurposeSelector/PurposeSelector.component'
import { purposeSelectorOptions } from '../../../commons/SearchBar/components/PurposeSelector/PurposeSelector.constants'
import Broker from '../../../../components/Brokers/item'
import { servicesByFocus } from '../../../commons/constants'

import './OurTeam.scss'

const OurTeamComponent = ({ brokers, directors, t }) => {

  const [option, setOption] = useState(purposeSelectorOptions.comercial)
  const [currentSector, setCurrentSector] = useState(servicesByFocus[1].sectorId)
  const [currentSubsidiary, setCurrentSubsidiary] = useState(servicesByFocus[1].subsidiaryId)
  const [team, setTeam] = useState([])

  useEffect(() => {
    setTeam(() => ([...directors, ...brokers].filter(
      (item) => item.sector == currentSector && (item.subsidiary == currentSubsidiary || !currentSubsidiary)
    )))
  }, [brokers, directors, setTeam, currentSector, currentSubsidiary])

  const selectionPurposeOption = (value) => {
    if (value !== option) {
      setOption(value)
      const newOptions = servicesByFocus.find((opt) => opt[`${value}Focus`])
      setCurrentSector(newOptions.sectorId)
      setCurrentSubsidiary(newOptions.subsidiaryId)
    }
  }

  const handleSelectSector = (value) => {
    setCurrentSector(value.sectorId)
    setCurrentSubsidiary(value.subsidiaryId)
  }

  return <div className='ljr-our-team container-fluid'>
    <div className='our-team-container'>
      <h1>{t('title')}</h1>
      <PurposeSelector
        className={'purpose-selector-our-team'}
        onSelectOption={selectionPurposeOption}
        value={option}
      />
      <div className={'our-team-options'}>
        {
          servicesByFocus
            .filter((teamOption) => {
              return teamOption[`${option}Focus`]})
            .map((teamOption) => (
              <Button
                key={`${teamOption.sectorId}_${teamOption.subsidiaryId}`}
                bsStyle='link'
                active={teamOption.sectorId === currentSector && teamOption.subsidiaryId == currentSubsidiary}
                onClick={() => handleSelectSector(teamOption)}
              >
                {t(teamOption.translationKey)}
              </Button>
          ))
        }
      </div>
      <div className='brokers-container'>
        <Row>
          {team.map((item, key) => (<Col md={3} sm={6} xs={6} key={key}>
            <Broker item={item} section={'section'} />
          </Col>))}
        </Row>
      </div>
    </div>
  </div>
}

export const OurTeam = translate('OurTeam')(OurTeamComponent)



// WEBPACK FOOTER //
// ./src/features/PageCompany/Components/OurTeam/OurTeam.comopnent.js